// removed by extract-text-webpack-plugin
module.exports = {"reportIssuesForm":"_1N59KwFI9P0zCBJjzuFKxP","formRow":"_1D4v9szaoWz_QUs1XtzaNf"};


//////////////////
// WEBPACK FOOTER
// ./src/components/ReportIssueForm/ReportIssueForm.scss
// module id = 1761
// module chunks = 0